// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"423":"owallet-bonuslist-page","425":"casino-page","799":"live-calendar","835":"registration-page"}[chunkId] || chunkId) + ".pl-PL.js";
};